import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { checkImgSrc } from '../../utils/common';
import * as $ from 'jquery';

interface menuItem {
  _id: number;
  title: string;
  thumb: string;
  selected?: boolean;
}
interface eventItem {
  id?: number;
  name: string;
  click: any;
  icon: string;
}
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-side-menu',
  templateUrl: './icc-side-menu.component.html',
  styleUrls: ['./icc-side-menu.component.less'],
})
export class IccSideMenuComponent implements OnChanges {
  @Input() header: {
    iconUrl: string;
    title: string;
  };
  @Input() list: Array<menuItem>;
  @Input() events: Array<eventItem>;
  @Input() readonly: boolean;
  @Output() change: EventEmitter<menuItem> = new EventEmitter<menuItem>();
  @Output() remove: EventEmitter<menuItem> = new EventEmitter<menuItem>();
  selectedItem: menuItem;
  currentTarget: any;
  showSideMenu: boolean;
  isInner: boolean;

  clickListener: any = () => {
    if (!this.isInner) {
      this.showSideMenu = false;
    }
    this.isInner = false;
  };
  constructor(private el: ElementRef) {}
  componentClick() {
    this.isInner = true;
  }
  ngOnChanges(changes: SimpleChanges) {
    // 补加 _id 和 selected，并确保有一个被选中
    let hasSelected = false;

    if (!this.list.length) {
      this.list.push({
        _id: new Date().getTime() + 1 * 1000,
        title: '',
        thumb: '',
      });
    }
    this.list.forEach((item, index) => {
      item._id = new Date().getTime() - index * 1000;
      if (!item.hasOwnProperty('selected')) {
        item.selected = false;
      } else if (item.selected && !hasSelected) {
        hasSelected = item.selected;
        this.selectedItem = item;
      } else {
        item.selected = false;
      }
      checkImgSrc(item.thumb).then(
        () => {
          // 地址有效
        },
        err => {
          if (err.type === 2) {
            // 地址无效
            item.thumb = './assets/images/nothing/invalid.png';
          }
        },
      );
    });
    if (!hasSelected && this.list.length) {
      this.list[0].selected = true;
      this.selectedItem = this.list[0];
    }
    if ((!this.events || !this.events.length) && !this.readonly) {
      this.events = [
        {
          id: 1,
          name: '写新图文',
          icon: 'edit',
          click: () => {
            console.log('请绑定事件');
          },
        },
      ];
    }

    document.addEventListener('click', this.clickListener);
  }
  // menu选中事件
  selectChange(evt, selectedItem) {
    if (this.selectedItem) {
      this.selectedItem.selected = false;
    }
    selectedItem.selected = true;
    this.selectedItem = selectedItem;
    this.currentTarget = evt.currentTarget;
    this.locationSideMenu();
    this.change.emit(selectedItem);
  }
  // 当鼠标在选中的menu上移动时，出现侧边操作菜单
  menuMove(item) {
    if (this.selectedItem && this.selectedItem._id === item._id) {
      this.locationSideMenu();
    }
  }
  // menu上移事件
  moveUp() {
    const selIndex = this.getSelectedIndex();
    if (selIndex !== undefined) {
      this.list.splice(selIndex - 1, 0, this.list.splice(selIndex, 1)[0]);
      this.showSideMenu = false;
    }
  }
  // menu下移事件
  moveDown() {
    const selIndex = this.getSelectedIndex();
    if (selIndex !== undefined) {
      this.list.splice(selIndex + 1, 0, this.list.splice(selIndex, 1)[0]);
      this.showSideMenu = false;
    }
  }
  // menu删除事件
  moveDelete() {
    const selIndex = this.getSelectedIndex();
    let deleteItem;
    if (selIndex !== undefined) {
      deleteItem = this.list.splice(selIndex, 1)[0];
      this.selectedItem = null;
      this.currentTarget = null;
      this.showSideMenu = false;
    }
    this.remove.emit(deleteItem);
  }
  // 新建消息
  addClick(event) {
    const length = this.list.length;
    event.click(event);
    if (length !== this.list.length) {
      const changedArray = this.list.filter(item => !item.hasOwnProperty('_id') || !item._id);
      if (changedArray.length) {
        changedArray.forEach((newItem, index) => {
          newItem._id = new Date().getTime() - index * Math.random() * 1000;
        });
      }
    }
    // 如果新建消息，选中最后一项新增项
    setTimeout(() => {
      this.selectedItem = this.list[this.list.length - 1];
    }, 100);
  }

  // 定位侧边浮动操作菜单
  locationSideMenu() {
    if (!this.currentTarget || this.list.length <= 1) {
      return false;
    }
    const timeout = setTimeout(() => {
      const $sideMenu = $(this.el.nativeElement).find('.hover-bars');
      const diffHalf = (this.currentTarget.clientHeight - $sideMenu[0].clientHeight) / 2;
      $sideMenu.css('top', this.currentTarget.offsetTop + diffHalf + 'px');
      // console.log(this.currentTarget.offsetTop + diffHalf + 'px');
      this.showSideMenu = true;
      clearTimeout(timeout);
    }, 0);
  }

  // 获取当前选中菜单的下标
  getSelectedIndex() {
    let selIndex;
    if (this.selectedItem && this.list instanceof Array && this.list.length) {
      for (let i = 0; i < this.list.length; i++) {
        if (this.selectedItem._id === this.list[i]._id) {
          selIndex = i;
          break;
        }
      }
    }
    return selIndex;
  }

  test() {
    console.log(`this.list`, this.list);
  }
}
